module.exports = __webpack_public_path__ + "8933de5d4eda246905c9d7215f5ef4d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2003_teaser_image.jpg
// module id = 555
// module chunks = 0